import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { useAuth } from "react-oidc-context";

export const Route = createFileRoute("/auth/logout")({
  component: AuthLogout,
});

function AuthLogout() {
  const auth = useAuth();
  const authRef = useRef(auth);
  authRef.current = auth;

  useEffect(() => {
    // Run exactly once on mount via stable ref — avoids re-firing on auth state changes.
    authRef.current.signoutRedirect().catch(() => {
      window.location.replace("/");
    });
  }, []);

  return (
    <div className="loading-screen">
      <output className="loading-mark" aria-label="Signing out…" />
    </div>
  );
}
